<label class="d-block mt-4"
  >Upload
  <span *ngIf="operationType === OPERATION_TYPES.MANUAL_FIX; else reconcile"
    >Manual Fix</span
  ><ng-template #reconcile>Reconciliation</ng-template> File</label
>
<div class="position-relative upload-file d-flex mt-2 mb-3">
  <input
    type="file"
    [hidden]="true"
    class="file-input"
    accept=".csv, .xls, .xlsx"
    (change)="onFileChange($event)"
    #fileUpload
  />
  <input
    id="filePath"
    type="text"
    name="fileInput"
    [value]="fileName"
    placeholder=".csv, .xlsx"
    class="input-md"
    (click)="fileUpload.value = ''; fileUpload.click()"
    readonly
  />
  <button
    psUiButton
    [disabled]="isDisableUpload"
    class="reconcile-innerbutton text-white button-recon"
    (click)="uploadAdjustmentsFile(operationType)"
  >
    Upload
  </button>
</div>
<!-- .xlsx file format-->
<a
  target="_blank"
  [href]="
    operationType === OPERATION_TYPES.MANUAL_FIX
      ? '../../../../assets/templates/Price Update Sample File v2.xlsx'
      : operationType === OPERATION_TYPES.LIVE
      ? '../../../../assets/templates/live-reconciliation.xlsx'
      : '../../../../assets/templates/closed-reconciliation.xlsx'
  "
  class="text-decoration-none"
>
  {{
    showDownloadTemplateText && operationType !== OPERATION_TYPES.MANUAL_FIX
      ? 'DOWNLOAD TEMPLATE'
      : 'DOWNLOAD SAMPLE'
  }}
</a>
<br /><br />

<a
  (click)="navigateToDashboard()"
  psUiButton
  class="btn btn-primary submit-btn"
  *ngIf="showBackToDashboardButton"
  >Back to Dashboard</a
>
